/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */
sew-ws-searchresult-list {
    @include component-spacing;
    @include grid;

    .headline {
        @include typo-ws-h2;

        margin: 0;
    }

    .main-content-container {
        display: grid;
        grid-template-columns: 2fr 1fr;
        column-gap: var(--column-gap);
    }

    .items {
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    &.top-search-list {
        .items {
            gap: 24px;
        }
    }

    @include mq-2 {
        .main-content-container {
            grid-template-columns: 1fr;
        }
    }
}

@include mq-1 {
    sew-ws-searchresult-list,
    sew-ws-searchresult-list.top-search-list {
        .items {
            gap: 20px;
        }
    }
}
